import { reject, resolve } from 'redux-optimist-promise';
import { FETCH_PROPOSALS_BY_ID, FETCH_SELECTED_PROPOSAL_PAYMENT, IS_BOOKING } from './constants';
type State = boolean;
const initialState: State = true;
export const isProposalLoadingReducer = (
  state: State = initialState,
  action: Action<any>,
): State => {
  switch (action.type) {
    case FETCH_SELECTED_PROPOSAL_PAYMENT:
    case FETCH_PROPOSALS_BY_ID:
      return true;

    case resolve(FETCH_SELECTED_PROPOSAL_PAYMENT):
    case resolve(FETCH_PROPOSALS_BY_ID):
    case reject(FETCH_PROPOSALS_BY_ID):
    case reject(FETCH_SELECTED_PROPOSAL_PAYMENT):
    case IS_BOOKING:
      return false;

    default:
      return state;
  }
};
